import { useContext } from 'react'
import SiteAssetsContext from '@/components/context/SiteAssetsContext'

const useSiteAssets = () => useContext(SiteAssetsContext)

export default useSiteAssets
